import { type MutableRefObject, useEffect } from 'react'

/** Unmount: cancel any animation frame a shape drag, text drag or pan drag still has pending. */
export function useRafCleanup({
  dragRafRef,
  textDragRafRef,
  panFrameRef,
}: {
  dragRafRef: MutableRefObject<number | null>
  textDragRafRef: MutableRefObject<number | null>
  panFrameRef: MutableRefObject<number | null>
}) {
  useEffect(() => {
    return () => {
      if (dragRafRef.current != null) {
        cancelAnimationFrame(dragRafRef.current)
        dragRafRef.current = null
      }

      if (textDragRafRef.current != null) {
        cancelAnimationFrame(textDragRafRef.current)
        textDragRafRef.current = null
      }

      if (panFrameRef.current != null) {
        cancelAnimationFrame(panFrameRef.current)
        panFrameRef.current = null
      }
    }
  }, [dragRafRef, textDragRafRef, panFrameRef])
}
